import { GridColDef } from '@mui/x-data-grid';
import { useGenGridCol } from 'src/utils/ComponentHelper';
import { TableColumnKey } from '../types/Table';

const useTableColumns = () => {
  const columns: GridColDef[] = [
    useGenGridCol(TableColumnKey.pfhNo),
    useGenGridCol(TableColumnKey.CreditCurrency),
    useGenGridCol(TableColumnKey.CreditAmount),
    useGenGridCol('validationPass'),
    useGenGridCol('validationError'),
  ];
  return { columns };
};
export default useTableColumns;
